import { render, staticRenderFns } from "./DraggableIFoodtems.vue?vue&type=template&id=0ba5fa9e&scoped=true"
import script from "./DraggableIFoodtems.vue?vue&type=script&lang=js"
export * from "./DraggableIFoodtems.vue?vue&type=script&lang=js"
import style0 from "./DraggableIFoodtems.vue?vue&type=style&index=0&id=0ba5fa9e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba5fa9e",
  null
  
)

export default component.exports